export const OHL = {
    voltage: '400',
    regionCode: 'INTER',
    name: 'DV 405 RP ĐERDAP 1 - granica/TS PORTILE DE FIER',
    stanice: [{name: 'ĐERDAP 1', position: {lat: 44.6652, lng: 22.5243}}],
    stubovi: [
        { index: 1, name: 'P', lat: 44.6647 , lng: 22.5245, sys: 1, portal: true},
        { index: 2, name: '1', lat: 44.664 , lng: 22.5241, sys: 1},
        { index: 3, name: '2', lat: 44.6631 , lng: 22.5272, sys: 1},
        { index: 4, name: '3', lat: 44.6624 , lng: 22.5298, sys: 1},
        { index: 5, name: '4', lat: 44.6662 , lng: 22.5341, sys: 1 }
    ],
    rasponi: [
        { name: 'P - 1', position: [{ lat: 44.6647 , lng: 22.5245 }, { lat: 44.664 , lng: 22.5241 }] },
        { name: '1 - 2', position: [{ lat: 44.664 , lng: 22.5241 }, { lat: 44.6631 , lng: 22.5272 }] },
        { name: '2 - 3', position: [{ lat: 44.6631 , lng: 22.5272 }, { lat: 44.6624 , lng: 22.5298 }] },
        { name: '3 - 4', position: [{ lat: 44.6624 , lng: 22.5298 }, { lat: 44.6662 , lng: 22.5341 }] }
    ]
}
